<template>
	<div class="log-item">
		<Tag v-if="!activeUsersMode" class="log-item-ev" :color="newItem.color" :title="newItem.tagTooltip">{{  newItem.tagContents }}</Tag>

		<span v-if="!parseItems" class="nobr log-item-raw">{{ newItem.raw }}</span>

		<DateTimeDisplay
			v-if="parseItems && newItem.time"
			class="log-item-time"
			:date="newItem.time"
			format="HH:mm:ss"
			:hideUtc="true"
			:title="newItem.timeTooltip"
		/>

		<WifiOutlined v-if="parseItems" class="pd-sm-x log-item-addr-icon"/>
		<span v-if="parseItems" class="log-item-addr nobr">{{ newItem.addr || '—' }}</span>

		<UserOutlined v-if="parseItems" :class="{'pd-sm-x': true, 'log-item-user-icon': true, 'hidden-element': ['SE', 'SC', 'SD'].includes(newItem.ev)}" />
		<span v-if="parseItems" :class="{'nobr': true, 'log-item-user': true, 'hidden-element': ['SE', 'SC', 'SD'].includes(newItem.ev)}">{{ newItem.user || '—' }}</span>

		<RoversIcon v-if="parseItems && activeUsersMode" class="pd-sm-x log-item-rovers-icon"/>
		<span v-if="parseItems && activeUsersMode" class="log-item-addr nobr">{{ newItem.count || '?' }}</span>

		<ExclamationCircleOutlined v-if="parseItems && newItem.err != null" class="pd-sm-x log-item-err-icon"/>
		<span v-if="parseItems && newItem.err != null" class="nobr">
			<Tag color="#9e332b">{{ newItem.err.code }}</Tag>
			{{ newItem.err.msg }}
		</span>

		<ExclamationCircleOutlined v-if="parseItems && newItem.respMsg != null && newItem.respMsg != ''" class="pd-sm-x log-item-err-icon"/>
		<span v-if="parseItems && newItem.respMsg != null && newItem.respMsg != ''" class="nobr">{{ newItem.respMsg }}</span>
	</div>
</template>

<script>
import { computed, toRef } from 'vue';

import { useI18n } from 'vue-i18n';

import { Tag } from 'ant-design-vue';
import { WifiOutlined, UserOutlined, ExclamationCircleOutlined } from '@ant-design/icons-vue';
import RoversIcon from '@/components/menu/RoversIcon.vue';

import { datetimeToStringFormat } from '@/components/common/dateUtils';

import { isErrorEvent } from '@/components/dashboard/userPulse/casterEventUtils';

import DateTimeDisplay from '@/components/common/DateTimeDisplay.vue';


const getEventColor = eventCode => ({
	SC: '#602b61',
	SD: '#602b61',
	SE: '#9e332b',
	CR: '#2b612f',
	CD: '#2b612f',
	CF: '#ab5011',
	CE: '#9e332b',
	CR_ERROR: '#9e332b',
}[eventCode] || '');


export default {
	components: {
		Tag,
		WifiOutlined, UserOutlined, ExclamationCircleOutlined,
		DateTimeDisplay,
		RoversIcon,
	},
	props: {
		item: {
			type: Object,
			required: true,
		},
		parseItems: {
			type: Boolean,
			required: true,
		},
		/*
		Эта настройка при true означает, что это список активных пользователей, а не бегущие логи со всеми событиями.
		Большая часть полей должна быть скрыта.
		*/
		activeUsersMode: {
			type: Boolean,
			required: false,
			default: false,
		},
	},
	setup(props) {
		const { t } = useI18n();
		const itemRef = toRef(props, 'item');
		const newItem = computed(() => {
			let result = typeof itemRef.value.data === 'string' ? JSON.parse(itemRef.value.data) : {...itemRef.value.data};
			delete result.id;
			result.raw = {...result};
			result.timeTooltip = datetimeToStringFormat(result.time, 'YYYY-MM-DD HH:mm:ss');
			if (result.ev === 'CR' && isErrorEvent(result)) {
				result.ev = 'CR_ERROR';
			}
			result.color = getEventColor(result.ev);
			result.tagContents = t('dashboard.userPulseLogs.events.' + result.ev);
			result.tagTooltip = '';
			if (result.ev === 'CE' && result.err) {
				result.tagTooltip = result.err.code + ': ' + result.err.msg;
			}
			return result;
		});
		return {
			newItem,
		};
	},
}
</script>

<style scoped>
.log-item {
	height: 22px;
	margin-block-end: 2px;
	display: flex;
	align-items: center;
}

.log-item-raw {
	font-family: SFMono-Regular,Consolas,Liberation Mono,Menlo,Courier,monospace;
}

.log-item-ev {
	flex-shrink: 0;
	width: 120px;
}

.log-item-time {
	flex-shrink: 0;
	width: 60px;
}

.log-item-addr-icon {
	color: #602B61;
}

.log-item-addr {
	flex-shrink: 0;
	min-width: 135px;
}

.log-item-user-icon {
	color: #2B612F;
}

.log-item-err-icon {
	color: #9e332b;
}

.log-item-user {
	min-width: 70px;
	padding-inline-end: 10px;
}

.log-item-rovers-icon {
	color: #602B61;
}

.hidden-element {
	visibility: hidden;
}
</style>
